import { dispatch, getState } from '../../store';

export const expandWidget = (): void => {
  const widgetState = getState();
  const {
    chatbot: { dealerOffer },
    tooltip,
  } = widgetState;
  dispatch('widget/expanded', true);
  dispatch('chatbot/unreadCount', 0);
  widgetState.chatbot.conversation.unreadCount = 0;
  widgetState.widget.expanded = true;

  if (dealerOffer && tooltip.isOpened) {
    dispatch('tooltip/close-per-offer', dealerOffer);
  }
};
